import React from 'react';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';

const CurrencyFormatter = ({
  allowNegative = false,
  getInputRef = undefined,
  ...other
}) => {
  return (
    <NumericFormat
      {...other}
      thousandSeparator
      decimalScale={2}
      prefix="$"
      allowNegative={allowNegative || false}
      getInputRef={getInputRef}
    />
  );
};

CurrencyFormatter.propTypes = {
  allowNegative: PropTypes.bool,
  getInputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.instanceOf(Element),
    }),
  ]),
};

export default CurrencyFormatter;
